import { useMemo } from 'react';

import { getBrCategoryOptions, getBrTypeOptions } from 'queries';
import { useTranslation } from 'react-i18next';

import { dateFormatter, nestedFieldValueGetter } from 'utils/grid';

import { GridColDef } from '@mui/x-data-grid-pro';

const detailsValueGetter = ({ row, field }) => row[field];

export const useGetColumns = (): GridColDef[] => {
  const { t } = useTranslation();

  const { data: brTypeOptions } = getBrTypeOptions();
  const { data: brCategoryOptions } = getBrCategoryOptions();

  return useMemo(
    () =>
      [
        {
          field: 'code',
          type: 'string',
          headerName: t('costCenters.grid.code'),
          hideable: false,
          valueGetter: detailsValueGetter,
          minWidth: 80
        },
        {
          field: 'nameShort',
          type: 'string',
          headerName: t('costCenters.grid.nameShort'),
          valueGetter: detailsValueGetter,
          flex: 1,
          minWidth: 150
        },
        {
          field: 'valid.from',
          type: 'date',
          headerName: t('validFrom'),
          valueGetter: nestedFieldValueGetter,
          valueFormatter: dateFormatter,
          flex: 1,
          maxWidth: 100
        },
        {
          field: 'valid.to',
          type: 'date',
          headerName: t('validTo'),
          valueGetter: nestedFieldValueGetter,
          valueFormatter: dateFormatter,
          flex: 1,
          maxWidth: 100
        }
      ] as GridColDef[],
    [t, brTypeOptions, brCategoryOptions]
  );
};
